	[{
	"errCode": "010000",
	 "value" : "Error occurred while processing request"
	},
	{
	 "errCode" : "010001",
	 "value" : "Invalid request"
	},
	{
	 "errCode" : "010002",
	 "value" : "validation failed for customer"
	},
	{
	 "errCode" : "010003",
	 "value" : "Error while parsing the request"
	},
	{
	 "errCode" : "010004",
	 "value" : "File missing"
	},
	{
	 "errCode" : "010005",
	 "value" : "File is invalid"
	},
	{
	 "errCode" : "010006",
	 "value" : "Storage URL not found Error"
	},
	{
	 "errCode" : "010007",
	 "value" : "Business Object not found"
	},
	{
	 "errCode" : "010008",
	 "value" : "Missing service Name or OTP"
	},
	{
	 "errCode" : "010009",
	 "value" : "Log file not found"
	},
	{
	 "errCode" : "010010",
	 "value" : "Invalid OTP"
	},
	{
	 "errCode" : "010011",
	 "value" : "Request has more ids than allowed Ids"
	},
	{
	 "errCode" : "010012",
	 "value" : "Changelog object not found"
	},
	{
	 "errCode" : "010013",
	 "value" : "Error occurred in _invoke get API"
	},
	{
	 "errCode" : "010014",
	 "value" : "Configuration key is missing in the payload"
	},
	{
	 "errCode" : "010015",
	 "value" : "Storage service could not be connected"
	},
	{
	 "errCode" : "010016",
	 "value" : "Change Log service could not be connected"
	},
	{
	 "errCode" : "010017",
	 "value" : "OTM Connector service could not be connected"
	},
	{
	 "errCode" : "010018",
	 "value" : "Augmentation service could not be connected"
	},
	{
	 "errCode" : "010019",
	 "value" : "Invalid JSON"
	},
	{
	 "errCode" : "010020",
	 "value" : "Authentication data is either missing or expired"
	},
	{
	 "errCode" : "020000",
	 "value" : "Error occurred while processing request"
	},
	{
	 "errCode" : "020001",
	 "value" : "Timeout occurred in Storage service"
	},
	{
	 "errCode" : "020002",
	 "value" : "Invalid Request, please check Request data"
	},
	{
	 "errCode" : "020003",
	 "value" : "Business Object Id is missing in json"
	},
	{
	 "errCode" : "020004",
	 "value" : "Business Object type is missing in json"
	},
	{
	 "errCode" : "020005",
	 "value" : "Invalid JSON, please check request data"
	},
	{
	 "errCode" : "020006",
	 "value" : "Configuration is either missing or wrong for this business type"
	},
	{
	 "errCode" : "020007",
	 "value" : "Reference payload for the Business Object type is missing"
	},
	{
	 "errCode" : "020008",
	 "value" : "Invalid Persistence Type"
	},
	{
	 "errCode" : "020009",
	 "value" : "Database is either down or cannot be connected"
	},
	{
	 "errCode" : "020010",
	 "value" : "Authentication failed for database"
	},
	{
	 "errCode" : "020011",
	 "value" : "Connectivity issue between Storage service and Config service"
	},
	{	
	 "errCode" : "020101",
	 "value" : "Invalid Request. No file specified"
	},
	{
	 "errCode" : "020102",
	 "value" : "Invalid Request. File not found"
	},
	{
	 "errCode" : "020200",
	 "value" : "Business Object could not be created"
	},
	{
	 "errCode" : "020201",
	 "value" : "SQL error occurred while creating the Business Object"
	},
	{
	 "errCode" : "020202",
	 "value" : "Bad SQL for Business Object creation"
	},
	{
	 "errCode" : "020203",
	 "value" : "Business Object could not be created, business object id already exists "
	},
	{
	 "errCode" : "020300",
	 "value" : "Business Object could not be retrieved"
	},
	{
	 "errCode" : "020301",
	 "value" : "Business Object not found"
	},
	{
	 "errCode" : "020302",
	 "value" : "Business Object is either not found or the status is duplicate"
	},
	{
	 "errCode" : "020303",
	 "value" : "Duplicate Business Object not found"
	},
	{
	 "errCode" : "020304",
	 "value" : "SQL Error Occurred while fetching the Business Object"
	},
	{
	 "errCode" : "020305",
	 "value" : "Bad SQL for fetching the Business Object"
	},
	{
	 "errCode" : "020306",
	 "value" : "No data is found for the filter"
	},
	{
	 "errCode" : "020307",
	 "value" : "No data is found for the suggestion"
	},
	{
	 "errCode" : "020400",
	 "value" : "Business Object could not be updated"
	},
	{
	 "errCode" : "020401",
	 "value" : "SQL Error occurred while updating the Business Object"
	},
	{
	 "errCode" : "020402",
	 "value" : "Bad SQL for update"
	},
	{
	 "errCode" : "020403",
	 "value" : "Update is rejected for the Business Object"
	},
	{
	 "errCode" : "020404",
	 "value" : "Zero record updated"
	},
	{
	 "errCode" : "020500",
	 "value" : "Business Object cannot be cancelled, please check update status"
	},
	{
	 "errCode" : "020501",
	 "value" : "SQL Error occurred while cancelling the Business Object"
	},
	{
	 "errCode" : "020502",
	 "value" : "Bad SQL for cancelling"
	},
	{
	 "errCode" : "020503",
	 "value" : "Cancel is rejected for this Business Object"
	},
	{
	 "errCode" : "020600",
	 "value" : "Error occurred while transformation"
	},
	{
	 "errCode" : "020601",
	 "value" : "No output on transformation"
	}
	]
